<div class="container-fluid">
    <div class="row" style="padding-bottom: 1em; padding-top: 0.6em;">
      <div class="col-sm-12">
        <div *ngIf="!loading && (savedQueriesData === null || savedQueriesData.length === 0)">
          <h5 style="text-align: center; color: #ffffff;">No saved queries</h5>
        </div>
        <kendo-listview *ngIf="savedQueriesData !== null && savedQueriesData.length > 0" [data]="savedQueriesData" [containerClass]="'k-d-flex k-flex-col k-flex-nowrap'">
          <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
            <app-query-card class="query" [query]="dataItem" [savedQuery]="true" (loadSelectedSavedQuery)="loadSavedQuery($event)">
            </app-query-card>
          </ng-template>
        </kendo-listview>
      </div>
    </div>
    <div class="row">
      <ngx-spinner [name]="'savedQueriesSpinner'" size="medium" [fullScreen]="false" type="ball-atom">
      </ngx-spinner>
    </div>
  </div>
  